import React from "react";
import { getExpiryBucket } from "../../utils/expiry";
import "./index.css";

/**
 * Small "Watcho · Expires today  ×" chip shown on a customer list when
 * it was opened from a dashboard expiry button. × clears the filter.
 */
const ExpiryFilterChip = ({ bucketKey, providerLabel, count, onClear }) => {
  const bucket = getExpiryBucket(bucketKey);
  if (!bucket) return null;
  return (
    <div className="expiry-filter-chip" role="status">
      <span>
        {providerLabel ? `${providerLabel} · ` : ""}
        {bucket.short}
        {count != null ? ` (${count})` : ""}
      </span>
      <button type="button" onClick={onClear} aria-label="Clear expiry filter" title="Clear filter">
        ×
      </button>
    </div>
  );
};

export default ExpiryFilterChip;
